"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exhaustivelyMatch = exports.dateTruncToString = exports.labelForGranularity = exports.getIconForDelta = exports.getIconForStatus = exports.getIconForLabel = exports.defaultComparisonFor = exports.getBAN = exports.isSingleNumberMetric = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var Localize_1 = require("../gen-src/Localize");
var SvgIcon_1 = require("./resources/SvgIcon");
var isSingleNumberMetric = function (data) {
    if (typeof data === 'number') {
        return true;
    }
    return data ? data.length <= 1 : true;
};
exports.isSingleNumberMetric = isSingleNumberMetric;
var getBAN = function (data, timestamp) {
    if (timestamp === void 0) { timestamp = new Date(); }
    return typeof data === 'number' ? { measure: data, timestamp: timestamp } : (0, metrics_engine_1.getLatestValue)(data);
};
exports.getBAN = getBAN;
var defaultComparisonFor = function (dateTrunc) { return ({
    comparisonPeriod: dateTrunc,
    numberOfPeriods: 1,
    type: 'HISTORICAL_COMPARISON',
    message: '',
}); };
exports.defaultComparisonFor = defaultComparisonFor;
var getIconForLabel = function (iconProps, status, definition, delta) {
    var _a;
    var statusIcon = (0, exports.getIconForStatus)(iconProps, status);
    var deltaLabelStyle = (_a = (0, metrics_engine_1.getLineStyleForDefaultThresholdLine)(definition)) === null || _a === void 0 ? void 0 : _a.deltaLabel;
    var deltaIcon = (0, exports.getIconForDelta)(iconProps, deltaLabelStyle, delta);
    return statusIcon || deltaIcon;
};
exports.getIconForLabel = getIconForLabel;
var getIconForStatus = function (iconProps, status) {
    switch (status) {
        case metrics_engine_1.ThresholdStatus.GOOD:
            return (0, SvgIcon_1.SvgIcon)(__assign(__assign({}, iconProps), { name: SvgIcon_1.SvgIconName.GOOD_STATUS }));
        case metrics_engine_1.ThresholdStatus.BAD:
            return (0, SvgIcon_1.SvgIcon)(__assign(__assign({}, iconProps), { name: SvgIcon_1.SvgIconName.BAD_STATUS }));
        case metrics_engine_1.ThresholdStatus.NEUTRAL:
        case metrics_engine_1.ThresholdStatus.UNKNOWN:
        default:
            return null;
    }
};
exports.getIconForStatus = getIconForStatus;
var getIconForDelta = function (iconProps, deltaLabelStyle, delta) {
    if (deltaLabelStyle === metrics_engine_1.DeltaLabelStyle.TARGET_VALUE || delta === undefined || delta.absolute === 0) {
        return null;
    }
    return (0, SvgIcon_1.SvgIcon)(__assign(__assign({}, iconProps), { name: delta.absolute > 0 ? SvgIcon_1.SvgIconName.POSITIVE_DELTA : SvgIcon_1.SvgIconName.NEGATIVE_DELTA }));
};
exports.getIconForDelta = getIconForDelta;
var labelForGranularity = function (dateGranularity) {
    switch (dateGranularity) {
        case metrics_engine_1.DateGranularity.SECOND: {
            return Localize_1.Messages.SecondsAgo();
        }
        case metrics_engine_1.DateGranularity.MINUTE: {
            return Localize_1.Messages.MinutesAgo();
        }
        case metrics_engine_1.DateGranularity.HOUR: {
            return Localize_1.Messages.HoursAgo();
        }
        case metrics_engine_1.DateGranularity.DAY: {
            return Localize_1.Messages.DaysAgo();
        }
        case metrics_engine_1.DateGranularity.WEEK: {
            return Localize_1.Messages.WeeksAgo();
        }
        case metrics_engine_1.DateGranularity.MONTH: {
            return Localize_1.Messages.MonthsAgo();
        }
        case metrics_engine_1.DateGranularity.QUARTER: {
            return Localize_1.Messages.QuartersAgo();
        }
        case metrics_engine_1.DateGranularity.YEAR: {
            return Localize_1.Messages.YearsAgo();
        }
        case metrics_engine_1.DateGranularity.UNKNOWN: {
            return Localize_1.Messages.MarksAgo();
        }
        default: {
            return '';
        }
    }
};
exports.labelForGranularity = labelForGranularity;
var dateTruncToString = function (dateTrunc) {
    switch (dateTrunc) {
        case metrics_engine_1.DateTrunc.SECOND: {
            return Localize_1.Messages.Seconds();
        }
        case metrics_engine_1.DateTrunc.MINUTE: {
            return Localize_1.Messages.Minutes();
        }
        case metrics_engine_1.DateTrunc.HOUR: {
            return Localize_1.Messages.Hours();
        }
        case metrics_engine_1.DateTrunc.DAY: {
            return Localize_1.Messages.Days();
        }
        case metrics_engine_1.DateTrunc.WEEK: {
            return Localize_1.Messages.Weeks();
        }
        case metrics_engine_1.DateTrunc.MONTH: {
            return Localize_1.Messages.Months();
        }
        case metrics_engine_1.DateTrunc.QUARTER: {
            return Localize_1.Messages.Quarters();
        }
        case metrics_engine_1.DateTrunc.YEAR: {
            return Localize_1.Messages.Years();
        }
        case metrics_engine_1.DateTrunc.UNKNOWN: {
            return Localize_1.Messages.Marks();
        }
        default: {
            return '';
        }
    }
};
exports.dateTruncToString = dateTruncToString;
function exhaustivelyMatch(_) {
    throw new Error('Should not have reached here');
}
exports.exhaustivelyMatch = exhaustivelyMatch;
//# sourceMappingURL=utils.js.map